const MDXLink = ({ text, href, label }: { text: string; href: string; label: string }) => {
	return (
		<a href={href} aria-label={label}>
			{text}
		</a>
	);
};

export default MDXLink;
